__turbopack_context__.v({
  "actionBtn": "nimage-module__TZNFUG__actionBtn",
  "caption": "nimage-module__TZNFUG__caption",
  "closeBtn": "nimage-module__TZNFUG__closeBtn",
  "imageBorder": "nimage-module__TZNFUG__imageBorder",
  "modal": "nimage-module__TZNFUG__modal",
  "modalBody": "nimage-module__TZNFUG__modalBody",
  "modalFooter": "nimage-module__TZNFUG__modalFooter",
  "modalHeader": "nimage-module__TZNFUG__modalHeader",
  "overlay": "nimage-module__TZNFUG__overlay",
  "zoomable": "nimage-module__TZNFUG__zoomable",
});
